import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Minimal SVG Icons
const DashboardIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

const TicketsIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2h12v6H6z" />
    <path d="M6 10h12v6H6z" />
    <path d="M6 18h12v2H6z" />
  </svg>
);

const ChatIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const KnowledgeIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v10H6.5z" />
    <circle cx="5" cy="5" r="1" fill={color} />
    <circle cx="5" cy="11" r="1" fill={color} />
  </svg>
);

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: 'Dashboard', icon: DashboardIcon, path: '/dashboard' },
    { label: 'Tickets', icon: TicketsIcon, path: '/tickets' },
    { label: 'Chat', icon: ChatIcon, path: '/chat' },
    { label: 'Knowledge', icon: KnowledgeIcon, path: '/kb' },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') return location.pathname === '/dashboard';
    if (path === '/tickets') return location.pathname.startsWith('/tickets');
    if (path === '/chat') return location.pathname.startsWith('/chat');
    if (path === '/kb') return location.pathname === '/kb';
    return false;
  };

  return (
    <nav style={styles.container}>
      <div style={styles.navItems}>
        {navItems.map((item) => {
          const isItemActive = isActive(item.path);
          const IconComponent = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                ...styles.navItem,
                ...(isItemActive ? styles.navItemActive : {}),
              }}
              title={item.label}
            >
              <span style={styles.icon}>
                <IconComponent color={isItemActive ? '#1e3a8a' : '#9ca3af'} />
              </span>
              <span style={styles.label}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

const styles = {
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e8eef5',
    zIndex: 1000,
    boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.1)',
  },
  navItems: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '0.75rem 0',
    maxWidth: '900px',
    margin: '0 auto',
  },
  navItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.4rem',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0.5rem 1rem',
    flex: 1,
    color: '#9ca3af',
    transition: 'color 0.2s, border 0.2s',
    pointerEvents: 'auto',
    minHeight: '48px',
    borderBottom: '2px solid transparent',
    fontFamily: "'Kanit', sans-serif",
  },
  navItemActive: {
    color: '#1e3a8a',
    borderBottomColor: '#1e3a8a',
  },
  icon: {
    fontSize: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
  label: {
    fontSize: '0.7rem',
    fontWeight: '500',
  },
};
